const moment = require("moment");

function is(value, type) {
    return Object.prototype.toString.apply(value) === `[object ${type}]`;
}

function getResponse(request, $default = null, transform = (body) => body) {
    if (!!request) {
        if (!!request.body) {
            let body = request.body;
            if (body.code === 200) {
                return transform(body);
            }
        }
    }

    return $default;
}

function array_set_value(array, values) {
    array.splice.apply(array, [0, array.length, ...values]);
}

function string_reverse(str) {
    return str.split('').reverse().join('');
}

function number_format(number, decimals = 2, config = {}) {
    let decimalSeparator = config.decimalSeparator;
    (decimalSeparator === undefined) && (decimalSeparator = '.');

    let millionSeparator = config.millionSeparator;
    (millionSeparator === undefined) && (millionSeparator = ',');

    let round = config.round;
    (round === undefined) && (round = false);

    let integerPart = Math.trunc(number);
    integerPart = String(integerPart);

    integerPart = string_reverse(integerPart);
    integerPart = integerPart.match(/.{1,3}/g);
    integerPart = integerPart.join(millionSeparator);
    integerPart = string_reverse(integerPart);

    let decimalPart = number % 1;
    let mult = 10 ** decimals;

    decimalPart = decimalPart * mult;
    decimalPart = round ? Math.round(decimalPart) : Math.trunc(decimalPart);
    decimalPart = decimalPart / mult;

    decimalPart = decimalPart.toFixed(decimals);
    decimalPart = decimalPart.split('.');

    let decimal = '';
    if (decimalPart.length === 2) {
        decimal = `${decimalSeparator}${decimalPart[1]}`
    }

    return `${integerPart}${decimal}`;
}

function toBracketNotation(obj, output, parentKey = undefined) {
    (output === undefined) && (output = {});
    if (is(obj, 'Object') || is(obj, 'Array')) {
        let _obj = (!!obj.toJSON) ? obj.toJSON() : obj;

        let keys = Object.keys(_obj);
        for (let key of keys) {
            let value = _obj[key];

            if (!!parentKey) {
                key = `${parentKey}[${key}]`;
            }

            if (!is(value, 'Object') && !is(value, 'Array')) {
                output[key] = value;
                continue;
            }

            toBracketNotation(value, output, key);
        }
    }

    return output;
}

window['toBracketNotation'] = toBracketNotation;

function toFormData(obj, formData) {
    (formData === undefined) && (formData = new FormData());
    if (!!obj) {

    }

    return formData;
}

function verifyPermissions(permissions, controller, action) {
    let modules = permissions.filter(p => p.name.toLowerCase() === controller.toLowerCase());
    if (modules.length > 0) {
        return modules[0].permisos.filter(p => p.toLowerCase() === action.toLowerCase()).length > 0;
    }
    return false;
}

function filterByField(data, field, value, parent) {
    if (field != null && value != null) {
        if (parent != null) {
            //return data.filter(d => typeof d[parent][field] === "string" ? d[parent][field].toLowerCase().includes(value.toLowerCase()) : (value == 0 || d[parent][field] == value) );
            return data.filter(d => (d[parent][field]) != null ? (d[parent][field]).toString().toLowerCase().includes((value).toString().toLowerCase()) : "");
        }
        //return data.filter(d => typeof d[field] === "string" ? d[field].toLowerCase().includes(value.toLowerCase()) : (value == 0 || d[field] == value) );
        return data.filter(d => (d[field]) != null ? d[field].toString().toLowerCase().includes((value).toString().toLowerCase()) : "");
    }
    return data;
}

function filterByFieldInt(data, field, value, parent) {
    if (field != null && value != null && value > 0) {
        if (parent != null) {
            return data.filter(d => d[parent][field] === value);
        }
        return data.filter(d => d[field] === value);
    }
    return data;
}

function filterByDate(data, iniDate, endDate, field, fieldRestrict, valueRestrict) {

    if (iniDate != null) {
        let _endDate = endDate == null ? moment().add(1, 'day') : moment(endDate).add(1, 'day');
        let _iniDate = moment(iniDate);

        if (fieldRestrict != null && valueRestrict != null) {
            //return data.filter(d => (moment(d[field]) >= moment(iniDate) && moment(d[field]) <= _endDate && d[fieldRestrict] === valueRestrict));
            return data.filter(d => (moment(d[field]).isBetween(_iniDate, _endDate, undefined, "[)") && d[fieldRestrict] === valueRestrict));
        }
        return data.filter(d => moment(d[field]).isBetween(_iniDate, _endDate, undefined, "[)"));
    }

    return data;

}

function searchByFields(data, fields, value) {
    if (fields != null && value != null && fields.length > 0 && value.length > 0) {
        let result = [];
        data.forEach(d => {
            for (let i = 0; i < fields.length; i++) {

                if (fields[i].indexOf(".") > -1) {
                    let p = fields[i].substr(0, fields[i].indexOf("."));
                    let f = fields[i].substr(fields[i].indexOf(".") + 1);
                    if (d[p][f].toString().toLowerCase().includes((value).toString().toLowerCase())) {
                        result.push(d);
                        break;
                    }
                } else {
                    let f = fields[i];
                    if (d[f].toString().toLowerCase().includes((value).toString().toLowerCase())) {
                        result.push(d);
                        break;
                    }
                }
            }
        });
        return result;
    }
    return data;
}

function generateStringRandom(length){
  let result           = '';
  let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let charactersLength = characters.length;
  for ( let i = 0; i < length; i++ ) {
    result += characters.charAt(Math.floor(Math.random() *
      charactersLength));
  }
  return result;
}

module.exports = {
    getResponse,
    array_set_value,
    number_format,
    string_reverse,
    toBracketNotation,
    verifyPermissions,
    filterByField,
    filterByFieldInt,
    filterByDate,
    searchByFields,
    searchByFields,
    generateStringRandom
}
